import { ClientKeyField, OriginField } from '@merchant-portal/credentials';
import React from 'react';
import styled from 'styled-components';
import { useAccess } from '../../hooks/useAccess';
import { useClientId } from '../../hooks/useClientId';
const RowContainer = styled.div.withConfig({ displayName: "RowContainer", componentId: "sc-1kvxj5t" }) `
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
const FieldContainer = styled.div.withConfig({ displayName: "FieldContainer", componentId: "sc-10jyzz6" }) `
  min-width: 310px;
  margin: 0 16px 0 0;
`;
export default function ClientKeyFields() {
    const { canCreateClientId } = useAccess();
    const { domainOrigin, clientIdToken } = useClientId();
    const shouldDisplayFields = canCreateClientId && domainOrigin && clientIdToken;
    if (!shouldDisplayFields)
        return null;
    return (React.createElement(RowContainer, null,
        React.createElement(FieldContainer, null,
            React.createElement(ClientKeyField, { clientKey: clientIdToken })),
        React.createElement(FieldContainer, null,
            React.createElement(OriginField, { origin: domainOrigin }))));
}
